import { render, staticRenderFns } from "./template-multiselect.vue?vue&type=template&id=2f09185a&"
import script from "./template-multiselect.vue?vue&type=script&lang=js&"
export * from "./template-multiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports